import React, { useEffect, useState } from 'react';
import api from '../services/api';

const RendicionCobradores: React.FC = () => {
  const [rendiciones, setRendiciones] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
  const [expandido, setExpandido] = useState<string | null>(null);

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/pagos/rendicion-todos?fecha=${fecha}`);
      setRendiciones(res.data);
    } catch {}
    finally { setLoading(false); }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { cargar(); }, [fecha]);

  const totalGeneral = rendiciones.reduce((s, r) => s + Number(r.totalCobrado), 0);
  const totalCobros = rendiciones.reduce((s, r) => s + r.cantidadCobros, 0);

  const coloresMetodo: Record<string, string> = {
    efectivo: '#22c55e', yape: '#8b5cf6', plin: '#38bdf8', transferencia: '#f59e0b'
  };

  const exportarCSV = () => {
    const rows = [
      ['Cobrador','Total Cobrado','Cantidad Cobros','Efectivo','Yape','Plin','Transferencia'],
      ...rendiciones.map(r => [
        `${r.cobrador?.nombre || ''} ${r.cobrador?.apellido || ''}`.trim(),
        Number(r.totalCobrado).toFixed(2),
        r.cantidadCobros,
        (r.porMetodo?.efectivo || 0).toFixed(2),
        (r.porMetodo?.yape || 0).toFixed(2),
        (r.porMetodo?.plin || 0).toFixed(2),
        (r.porMetodo?.transferencia || 0).toFixed(2),
      ])
    ];
    const csv = '﻿' + rows.map(r => r.map(c => `"${String(c).replace(/"/g,'""')}"`).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = `rendicion-${fecha}.csv`; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h2 style={{ color:'#f1f5f9', margin:0, fontSize:24, fontWeight:800 }}>Rendicion Cobradores</h2>
          <p style={{ color:'#64748b', margin:'4px 0 0', fontSize:13 }}>Resumen diario de cobros por cobrador</p>
        </div>
        <div style={{ display:'flex', gap:10, alignItems:'center' }}>
          <input type="date" value={fecha} onChange={e => setFecha(e.target.value)}
            style={{ background:'#1e293b', border:'1px solid #334155', borderRadius:8, padding:'8px 12px', color:'white', fontSize:13 }} />
          <button onClick={exportarCSV}
            style={{ background:'#0f172a', border:'1px solid #334155', color:'#94a3b8', padding:'8px 14px', borderRadius:8, cursor:'pointer', fontWeight:600, fontSize:13 }}>
            📥 CSV
          </button>
          <button onClick={cargar}
            style={{ background:'#0ea5e922', border:'1px solid #0ea5e944', color:'#38bdf8', padding:'8px 14px', borderRadius:8, cursor:'pointer', fontWeight:600, fontSize:13 }}>
            ↻ Actualizar
          </button>
        </div>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:20 }}>
        {[
          { label:'Total cobrado', value:`S/. ${totalGeneral.toFixed(2)}`, color:'#22c55e' },
          { label:'Total cobros', value: totalCobros, color:'#38bdf8' },
          { label:'Cobradores activos', value: rendiciones.length, color:'#f59e0b' },
        ].map(s => (
          <div key={s.label} style={{ background:'#1e293b', borderRadius:10, padding:'14px 18px', border:`1px solid ${s.color}33` }}>
            <div style={{ color:'#64748b', fontSize:12 }}>{s.label}</div>
            <div style={{ color:s.color, fontSize:22, fontWeight:800 }}>{s.value}</div>
          </div>
        ))}
      </div>

      {loading ? (
        <div style={{ color:'#64748b', textAlign:'center', padding:48 }}>Cargando...</div>
      ) : rendiciones.length === 0 ? (
        <div style={{ background:'#1e293b', borderRadius:12, padding:32, textAlign:'center', color:'#64748b', border:'1px solid #334155' }}>
          Sin cobros registrados para esta fecha
        </div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          {rendiciones.sort((a,b) => b.totalCobrado - a.totalCobrado).map(r => {
            const nombre = `${r.cobrador?.nombre || ''} ${r.cobrador?.apellido || ''}`.trim() || 'Sin nombre';
            const isExp = expandido === r.cobradorId;
            return (
              <div key={r.cobradorId} style={{ background:'#1e293b', borderRadius:12, border:'1px solid #334155', overflow:'hidden' }}>
                <div
                  onClick={() => setExpandido(isExp ? null : r.cobradorId)}
                  style={{ padding:'16px 20px', cursor:'pointer', display:'flex', alignItems:'center', gap:16 }}>
                  <div style={{
                    width:44, height:44, borderRadius:'50%',
                    background:'#22c55e22', border:'1px solid #22c55e44',
                    display:'flex', alignItems:'center', justifyContent:'center',
                    color:'#22c55e', fontWeight:800, fontSize:15, flexShrink:0
                  }}>
                    {nombre.split(' ').map((p:string) => p[0]).join('').slice(0,2).toUpperCase()}
                  </div>
                  <div style={{ flex:1 }}>
                    <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:15 }}>{nombre}</div>
                    <div style={{ color:'#64748b', fontSize:12, marginTop:2 }}>{r.cantidadCobros} cobro{r.cantidadCobros !== 1 ? 's' : ''}</div>
                  </div>
                  <div style={{ textAlign:'right' }}>
                    <div style={{ color:'#22c55e', fontWeight:800, fontSize:20 }}>S/. {Number(r.totalCobrado).toFixed(2)}</div>
                    <div style={{ color:'#64748b', fontSize:11, marginTop:2 }}>
                      {Object.entries(r.porMetodo || {}).map(([m,v]) => `${m}: S/.${(v as number).toFixed(0)}`).join(' · ')}
                    </div>
                  </div>
                  <div style={{ color:'#475569', fontSize:18 }}>{isExp ? '▲' : '▼'}</div>
                </div>

                {isExp && (
                  <div style={{ borderTop:'1px solid #334155' }}>
                    {/* Metodos */}
                    {Object.keys(r.porMetodo || {}).length > 0 && (
                      <div style={{ padding:'12px 20px', display:'flex', gap:10, borderBottom:'1px solid #1e293b' }}>
                        {Object.entries(r.porMetodo).map(([m,v]) => (
                          <div key={m} style={{
                            background:`${coloresMetodo[m] || '#64748b'}22`,
                            border:`1px solid ${coloresMetodo[m] || '#64748b'}44`,
                            borderRadius:8, padding:'6px 12px', fontSize:12,
                            color: coloresMetodo[m] || '#94a3b8',
                          }}>
                            <span style={{ textTransform:'uppercase', fontWeight:700 }}>{m}</span>
                            <span style={{ marginLeft:8 }}>S/. {(v as number).toFixed(2)}</span>
                          </div>
                        ))}
                      </div>
                    )}
                    {/* Lista de pagos */}
                    <div style={{ maxHeight:300, overflowY:'auto' }}>
                      {(r.pagos || []).map((p:any) => {
                        const fecha2 = new Date(p.createdAt);
                        const hora = `${fecha2.getHours().toString().padStart(2,'0')}:${fecha2.getMinutes().toString().padStart(2,'0')}`;
                        return (
                          <div key={p.id} style={{ padding:'10px 20px', borderBottom:'1px solid #0f172a', display:'flex', alignItems:'center', gap:12 }}>
                            <div style={{ color:'#22c55e', fontSize:16 }}>✓</div>
                            <div style={{ flex:1 }}>
                              <span style={{ color:'#f1f5f9', fontSize:13, fontWeight:500 }}>
                                {p.cliente?.nombres} {p.cliente?.apellidos}
                              </span>
                              <span style={{ color:'#475569', fontSize:11, marginLeft:8 }}>{hora}</span>
                            </div>
                            <div style={{ color:'#22c55e', fontWeight:700 }}>S/. {Number(p.monto).toFixed(2)}</div>
                            <div style={{ color:`${coloresMetodo[p.metodo] || '#64748b'}`, fontSize:11, background:`${coloresMetodo[p.metodo] || '#64748b'}22`, padding:'2px 8px', borderRadius:20 }}>
                              {p.metodo}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default RendicionCobradores;
